import axios from 'axios'

export const useAuthRequests = () => {

  const loginRequest = async (email,password) => {
    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_API+process.env.REACT_APP_LOGIN}`,
      data: {
        username: email,
        password: password
      },
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        'Target-URL' : `${process.env.REACT_APP_API+process.env.REACT_APP_LOGIN}`
      }
    })
  }
  const setCurrency = async (currency) => {
    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_API+process.env.REACT_APP_SET_CURRENCY}?currencyUnit=${currency}`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `${localStorage.getItem('ulusoytoken')}`,
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        'Target-URL' : `${process.env.REACT_APP_API+process.env.REACT_APP_SET_CURRENCY}`
      }
    })
  }
  const getCustomer=async (token)=>{
    return axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API+process.env.REACT_APP_CUSTOMER}`,
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        'Target-URL' : `${process.env.REACT_APP_API+process.env.REACT_APP_REGISTER}`,
        'Authorization': `${token}`
      }
    })
  }
  const registerRequest = async (data) => {
    return axios({
      method: "post",
      url: `${process.env.REACT_APP_API + process.env.REACT_APP_REGISTER}`,
      data: {
        name: data.name,
        surname: data.surname,
        email: data.email,
        // companyTitle: data.company,
        phoneNumber: data.phoneNumber,
        // phoneNumber2:phoneNumber2,
        address: data.address,
        password: data.password,
        // guarantorName: guarantorName,
        // guarantorPhoneNumber: guarantorPhoneNumber,
      },
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        "Target-URL": `${
          process.env.REACT_APP_API + process.env.REACT_APP_REGISTER
        }`,
      },
    });
  }
  
  const forgotRequest = async (data) => {
    return axios({
      method: "GET",
      url: `${
        process.env.REACT_APP_API +
        process.env.REACT_APP_SEND_VERIFY_CODE +
        "?emailAddress=" +
        data
      }`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        "Target-URL": `${
          process.env.REACT_APP_API + process.env.REACT_APP_SEND_VERIFY_CODE
        }`,
      },
    });
  };
  const forgotRequestFinal = async (data) => {
    return axios({
      method: "GET",
      url: `${
        process.env.REACT_APP_API +
        process.env.REACT_APP_CHANGE_PASSWORD_WITH_VERIFY +
        "?emailAddress=" +
        data.email +
        "&newPassword=" +
        data.password +
        "&verifyCode=" +
        data.code
      }`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        "Target-URL": `${
          process.env.REACT_APP_API +
          process.env.REACT_APP_CHANGE_PASSWORD_WITH_VERIFY
        }`,
      },
    });
  };

  const changePasswordRequest = async (data) => {
    return axios({
      method: "post",
      url: `${
        process.env.REACT_APP_API + process.env.REACT_APP_CHANGE_PASSWORD
      }`,
      data: data,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        "Target-URL": `${
          process.env.REACT_APP_API + process.env.REACT_APP_CHANGE_PASSWORD
        }`,
        Authorization: `${localStorage.getItem("ulusoytoken")}`,
      },
    });
  };
  
  return {
    loginRequest,
    registerRequest,
    getCustomer,
    setCurrency,
    changePasswordRequest,
    forgotRequest,
    forgotRequestFinal,
  };
}